import React, {Fragment, useEffect, useState} from 'react'
import localization from "../../../../../assets/localization/localization";
import TableSection from "../../../../../components/sales/tableSection/tableSection";
import Layout from "../../../../../components/sales/layout/layout";
import Filter from "../Filter";
import {Button} from "react-bootstrap";
import Images from "../../../../../assets/images/imageData";

const VariableInvoice = ({
                             getValetContractInvoice,
                             valetContractInvoice=[]
                         }) => {
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [showFilter, setShowFilter] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getValetContractInvoice(1, 2)
            setIsLoading(false)
        })()
    }, []);

    const headers = [
        "Invoice Id",
        'Invoice Number',
        'Invoice Type',
        'Invoice Date',
        'Net Payable',
        // 'Creation Source',
        // 'status',
        'Installment Type',
        // 'Ti Number',
        'Actions'
    ];

    useEffect(() => {
        if (valetContractInvoice && valetContractInvoice?.resultSets && valetContractInvoice?.resultSets.length > 0) {
            const tableData = ['invoice_id', 'invoice_number','invoice_type','invoice_date','net_payable', 'installment_type'];
            const action = [{name: 'Edit', link: `valet-variable-invoice-edit`}];
            const data = valetContractInvoice?.resultSets.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'installment_type' ? {[key]: 'Variable'} : key === 'invoice_type' ? {[key]: element[key] === 1 ? 'Pre' : 'Post'} : {[key]: element[key]}
                    )),
                    {},
                    {Action: [{name: 'Edit', link: `valet-variable-invoice-edit/${element['invoice_id']}`},
                            {name: 'View', link: `valet-approval-action-invoice-list/${element['invoice_id']}`}
                        ]}
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(valetContractInvoice.total / valetContractInvoice.per_page));
        }
    }, [valetContractInvoice])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getValetContractInvoice(val.selected + 1, 2);
        setIsLoading(false);
    };

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem("valet_invoice_b2b", JSON.stringify(filterData));
        await getValetContractInvoice(1, 2, filterData);
        setIsLoading(false);
        filterToggle();
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <>
                <Fragment>
                    <Button
                        onClick={filterToggle}
                        className="filter-hamburger btn btn-transparent"
                    >
                        <img src={Images?.Filter} alt=""></img>
                        {localization.showFilters}
                    </Button>
                </Fragment>
            </>
        );
    };

    return (
        <>
            <Layout
                title={localization.VariableValetInvoice}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={valetContractInvoice && valetContractInvoice.resultSets}
                    srNo={valetContractInvoice?.from}
                />
            </Layout>

            <Filter
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
            />
        </>
    )
}

export default VariableInvoice